import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';
import { TextSize, TextSkin, TextWeight } from './index';

export interface TextDriver extends BaseDriver {
  getTagName: () => string;
  getText: () => string;
  getSize: () => TextSize;
  getSkin: () => TextSkin;
  getWeight: () => TextWeight;
  getId: () => string;
  isLight: () => boolean;
  isSecondary: () => boolean;
  isMasked: () => boolean;
  isWidows: () => boolean;
}
